<template>
  <div class="new-order-aside-component">
    <v-navigation-drawer
      id="default-drawer"
      dark
      :right="$vuetify.rtl"
      mini-variant-width="80"
      app
      width="260"
    >
      <div
        v-if="showAttentionMessage"
        class="attention-section d-flex align-center justify-center"
      >
        <div
          class="attention-window d-flex flex-column justify-center align-center"
        >
          <span class="title font-weight-regular">Внимание</span>
          <span class="sub-title">Сначала создайте клиента!</span>
          <v-btn
            @click="showAttentionMessage = false"
            class="button-apply"
            color="#FF9100"
            depressed
          >
            Ok
          </v-btn>
        </div>
      </div>

      <perfect-scrollbar :options="{ suppressScrollX: true }">
        <aside-logo/>

        <div class="aside-container align-center">
          <div class="d-flex justify-lg-space-between">
            <div class="clocks-section">
              <span class="aside-title">Новый заказ</span>
              <span class="date">{{ day }} {{ month }} {{ week }} {{ hours }}:{{ minutes }}</span>
            </div>
            <div class=" aggregate-section d-flex align-center ">
              <aggregator-select />
            </div>
          </div>
          <v-btn
            @click="back"
            class="button-back text-normalize font-weight-medium"
            width="100%"
          >
            <font-awesome-icon icon="chevron-left" />
            Назад к списку заказов
          </v-btn>
          <order-help />
          <v-menu @showAttentionMessage="showAttentionMessage = true" />
        </div>
      </perfect-scrollbar>
      <div class="pt-12" />
    </v-navigation-drawer>
  </div>
</template>

<script>
  import OrderHelp from './OrderHelp'
  import VMenu from './Menu'
  import mixinGetDatatime from '@/mixins/get-datatime'
  import AggregatorSelect from './AggregatorSelect'
  import AsideLogo from '@/components/aside/AsideLogo'

  export default {
    name: 'NewOrderAside',
    mixins: [mixinGetDatatime],
    components: {
      AsideLogo,
      OrderHelp,
      VMenu,
      AggregatorSelect,
    },
    data () {
      return {
        showAttentionMessage: false,
        asideWidth: 260,
      }
    },
    methods: {
      back () {
        this.$router.push('/orders')
      },
    },
  }
</script>

<style lang="less">
.new-order-aside-component {
  .v-list-item {
    margin-bottom: 8px;
  }

  .theme--dark.v-navigation-drawer {
    background-color: #040404;
  }

  .v-list-item::before,
  .v-list-item::after {
    display: none;
  }

  .v-list-group__header__prepend-icon,
  .v-list-item__icon {
    margin-top: 12px;
    margin-bottom: 12px;
    margin-left: 4px;
  }

  &.v-navigation-drawer--mini-variant {
    .v-list-item {
      justify-content: flex-start !important;
    }
  }

  .ps {
    height: 100%;
  }

  .v-navigation-drawer__content {
    height: auto;
    overflow-y: hidden;
  }
}
</style>

<style lang="less" scoped>
.new-order-aside-component {
  position: relative;
  z-index: 0;
  .attention-section {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#040404, 0.85);
    z-index: 1;
    .attention-window {
      background-color: #ffffff;
      padding: 54px 50px 26px;
      border-radius: 10px;
      .title {
        display: block;
        margin-bottom: 8px;
        font-size: 25px !important;
        line-height: 1;
      }
      .sub-title {
        display: block;
        font-size: 14px;
        line-height: 17px;
        margin-bottom: 35px;
      }
      .button-apply {
        font-size: 15px;
        line-height: 21px;
        height: 80px;
        width: 145px;
      }
    }
  }
  .logo-section {
    padding-left: 18px;
    padding-top: 18px;
    margin-bottom: 18px;
  }

  .aside-container {
    padding: 0 16px 0 18px;

    .clocks-section {
      margin-bottom: 17px;
      .aside-title {
        display: block;
        color: @color-primary;
        font-size: 25px;
        line-height: 1;
      }
      .date {
        color: #ffffff;
        font-size: 14px;
        line-height: 17px;
      }
    }
    .button-back {
      font-size: 16px;
      line-height: 19px;
      height: 50px;
      background-color: #191919 !important;
      svg {
        margin-right: 12px;
        .fill-svg(#0033ff);
      }
    }
  }
}
</style>
